export class Observable {
  private currentValue: any = null;
  private subscribers: Function[] = [];

  constructor(startValue: any = null, startFn: Function | null = null) {
    this.currentValue = startValue;
    if (startFn != null) {
      startFn(this);
    }
  }

  public subscribe(fn: Function): void {
    this.subscribers.push(fn);
    fn(this.currentValue);
  }

  public next(value: any) {
    this.subscribers.forEach(sub => {
      sub(value);
    });
  }
}